import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Translation } from 'react-i18next'
import {
  sendReferralCodeValidate,
  validateSSN
} from '../../containers/validate'
import { useHistory } from 'react-router-dom'
import store from '../../store'
import { Form, Field, useForm } from '../../form'
import classNames from 'classnames'
import { Snackbar } from '@material-ui/core'
import { MySnackbarContentWrapper } from '../../utils/snackbar.utils'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import FontAwesome from 'react-fontawesome'
import { Link } from 'react-router-dom'

class NewSalarySummaryComponent extends React.Component {
  render() {
    return <NewSalarySummary {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px'
    },
    [theme.breakpoints.down('400')]: {
      padding: '0 5px'
    }
  },
  tablecell1: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px'
    },
    [theme.breakpoints.down('400')]: {
      padding: '0 5px'
    }
  },
  button: {
    margin: theme.spacing(1),
    marginRight: 15
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textField: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '45px'
    },
    [theme.breakpoints.down('335')]: {
      marginTop: '60px'
    }
  },
  resize: {
    fontSize: '14px'
  },
  subTitle: {
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'center',
    margin: '0px 20px 0px 20px'
  }
})

const defaultValues = {
  referralCode: ''
}

const NewSalarySummary = ({
  newSalarySummary,
  postSalary,
  salaries,
  warnToAddCost,
  cancelPaySalary,
  warnNoSSN,
  classes,
  showDialog,
  closeDialogSalary,
  sendReferralCode,
  allSalaries,
  sendCodeSuccess,
  sendCodeFailed,
  nerverUseDiscount,
  closeSalarySnackbar,
  selectedRows,
  discount,
  handleRefreshClick,
  isCodeActivated
}) => {
  const history = useHistory()

  // KAS-336 Gross salary without VAT
  const gross_salary_without_vat = newSalarySummary.sumInvWithoutTax
  const instant_payment = newSalarySummary.instant_payment[0]
  const isGroupInvoice = newSalarySummary.isGroupInvoice[0] === 1 ? true : false

  const form = useForm({
    name: 'referralCode',
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validator: sendReferralCodeValidate
  })
  const { control } = form

  function onSubmit(values) {
    sendReferralCode(values)
  }

  // KAS-336 Never get discount
  const neverDiscount = {
    referralCode: '@denyDiscount'
  }

  const isNormalNewSalary = () => {
    const { status, isPartial, isGroupInvoice } = newSalarySummary
    return (
      status !== undefined &&
      status[0] !== 15 &&
      status[0] !== 16 &&
      (status[0] === 2 || status[0] === 24 || status[0] === 5) &&
      !isPartial[0] &&
      !isGroupInvoice[0]
    )
  }
  return (
    <Translation>
      {(t) => {
        //console.log('salary ssn: ', store.getState().profile.userData.ssn)
        //console.log(postSalary)
        //console.log(salaries)
        return (
          <div className="dashboard-content-header">
            <div className="col-md-6 col-sm-6">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="panel-title">{t('newSalarySummary.div')}</h3>
                </div>
                <div className={classes.root}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '70%' }}
                        >
                          <div className="dashboard-salary-header">
                            {t('newSalarySummary.table')}
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '30%' }}
                        />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('newSalarySummary.table2')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.sumWithTax)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <hr />
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '70%' }}
                        >
                          <div className="dashboard-salary-header">
                            {t('newSalarySummary.table3')}
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '30%' }}
                        />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('newSalarySummary.table4')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.sumInvWithoutTax)}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('newSalarySummary.table11')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {
                            // KAS-336 Show discount with condition
                            discount ? (
                              <div className="red">0,00 €</div>
                            ) : (
                              new Intl.NumberFormat('fi-FI', {
                                style: 'currency',
                                currency: 'EUR'
                              }).format(newSalarySummary.palvelu)
                            )
                          }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('newSalarySummary.table12')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.quick_pay_cost)}
                        </TableCell>
                      </TableRow>

                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('newSalarySummary.table13')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.social_contri)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          <b>{t('newSalarySummary.table7')}</b>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.gross_sum)}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('newSalarySummary.table8')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.tax_percentage)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          <b>{t('newSalarySummary.table9')}</b>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.net_sum)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('newSalarySummary.table5')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.allowances_cost)}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('newSalarySummary.table6')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.expense_cost_with_vat)}
                        </TableCell>
                      </TableRow>
                      {newSalarySummary.isnormalgovpay ||
                      newSalarySummary.isbruttogovpay ? (
                        <TableRow style={{ background: '#ebf9fa' }}>
                          <TableCell
                            className={classes.tablecell1}
                            style={{ width: '70%' }}
                          >
                            {t('newSalarySummary.table17')}
                          </TableCell>
                          <TableCell
                            className={classes.tablecell1}
                            style={{ width: '30%' }}
                          >
                            {new Intl.NumberFormat('fi-FI', {
                              style: 'currency',
                              currency: 'EUR'
                            }).format(
                              newSalarySummary.isnormalgovpay
                                ? newSalarySummary.normal_ulosotto_sum
                                : newSalarySummary.brutto_ulosotto_sum
                            )}
                          </TableCell>
                        </TableRow>
                      ) : null}
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('newSalarySummary.table10')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.yel_insurance)}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          <b>{t('newSalarySummary.table15')}</b>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalarySummary.deductions_sum)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <hr />
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '70%' }}
                        >
                          <div className="dashboard-salary-header">
                            {t('newSalarySummary.table16')}
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '30%' }}
                        >
                          <div className="dashboard-salary-header">
                            {new Intl.NumberFormat('fi-FI', {
                              style: 'currency',
                              currency: 'EUR'
                            }).format(newSalarySummary.paid_sum)}
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </div>
                <div
                  className="row"
                  style={{
                    marginRight: '-1px',
                    padding: '15px 20px 20px 0px'
                  }}
                >
                  <div className="pull-right">
                    <Button
                      variant="contained"
                      className={classes.button}
                      type="submit"
                      onClick={() => warnToAddCost()}
                    >
                      {t('newSalarySummary.button')}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <Dialog
              open={store.getState().salary.isToAdd}
              onClose={cancelPaySalary}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {isNormalNewSalary()
                    ? t('newSalarySummary.dialogTitle')
                    : null}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {isNormalNewSalary()
                      ? t('newSalarySummary.dialogContent')
                      : t('newSalarySummary.dialogContent1')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  {isNormalNewSalary() && (
                    <Button
                      variant="outlined"
                      className={classes.button}
                      type="submit"
                      component={Link}
                      to="/dashboard/fee"
                      onClick={cancelPaySalary}
                    >
                      {t('newSalarySummary.cancelButton')}
                    </Button>
                  )}
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={() => {
                      let ssn = store.getState().profile.userData.ssn
                      if (ssn && validateSSN(ssn)) {
                        postSalary(salaries)
                      } else warnNoSSN()
                    }}
                  >
                    {t('newSalarySummary.YesButton')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <Dialog
              open={store.getState().salary.isNoSSN}
              onClick={cancelPaySalary}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('newSalarySummary.titleNoSSN')}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('newSalarySummary.contentNoSSN')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions className={classes.buttonContainer}>
                <div>
                  <Button
                    variant="contained"
                    className={classes.button}
                    onClick={() => {
                      cancelPaySalary()
                      history.push('/dashboard/profile')
                    }}
                  >
                    {t('newSalarySummary.navigateToProfile')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            {/* Referral program dialog: to send referral code for discount and warning the salary does not match condition */}
            <Dialog
              open={
                showDialog &&
                gross_salary_without_vat < 500 &&
                allSalaries.length < 4 &&
                selectedRows.length === 1
              }
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              {/* Gross salary is less than 500e */}
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '25px' }}>{t('referral.title3')}</span>
              </DialogTitle>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={closeDialogSalary}
                  >
                    {t('referral.btn')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            {/* KAS-356 Don't apply discount for quick pay invoice */}
            <Dialog
              open={
                showDialog &&
                gross_salary_without_vat >= 500 &&
                (instant_payment === 'quick_pay' || isGroupInvoice) &&
                allSalaries.length < 4 &&
                selectedRows.length === 1
              }
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '25px' }}>{t('referral.title6')}</span>
              </DialogTitle>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={closeDialogSalary}
                  >
                    {t('referral.btn')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <Dialog
              open={
                showDialog &&
                (gross_salary_without_vat < 500 ||
                  (gross_salary_without_vat >= 500 &&
                    (instant_payment === 'quick_pay' || isGroupInvoice))) &&
                allSalaries.length === 4 &&
                selectedRows.length === 1
              }
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              {/* KAS-336 Last warning to send the code - when choosing small amout */}
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>{t('referral.title5')}</span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  <span style={{ fontSize: '14px' }}>
                    {t('referral.subtitle5')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    className={classes.button}
                    onClick={closeDialogSalary}
                  >
                    {t('referral.btn')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
            <Dialog
              open={
                showDialog &&
                gross_salary_without_vat >= 500 &&
                instant_payment !== 'quick_pay' &&
                !isGroupInvoice &&
                allSalaries.length < 4 &&
                selectedRows.length === 1
              }
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              {/* Do you want to activate your code now */}
              <DialogTitle id="alert-dialog-title" style={{ paddingBottom: 0 }}>
                <span style={{ fontSize: '20px' }}>{t('referral.title2')}</span>
              </DialogTitle>
              <Form {...form}>
                <DialogContent style={{ paddingTop: 0 }}>
                  <Field
                    name="referralCode"
                    label={t('referral.subtitle2')}
                    inputType="textfield"
                    className={classNames(classes.textField, classes.resize)}
                    control={control}
                  />
                  <div className="red" style={{ paddingTop: '10px' }}>
                    <p>
                      <i>{t('referral.subtitle3')}</i>
                    </p>
                  </div>
                </DialogContent>
                <DialogActions>
                  <div className="pull-right">
                    <Button
                      variant="outlined"
                      className={classes.button}
                      onClick={closeDialogSalary}
                    >
                      {t('referral.btn2')}
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      className={classes.button}
                    >
                      {t('referral.btn3')}
                    </Button>
                  </div>
                </DialogActions>
              </Form>
            </Dialog>
            {/* KAS 336, show dialog to sent referral code before expired */}
            <Dialog
              open={
                showDialog &&
                gross_salary_without_vat >= 500 &&
                instant_payment !== 'quick_pay' &&
                !isGroupInvoice &&
                allSalaries.length === 4 &&
                selectedRows.length === 1
              }
              onClose={handleRefreshClick}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              {/* KAS-359: The final box have a close button in top (X) */}
              <div>
                <div style={{ float: 'right' }}>
                  <IconButton
                    aria-label="close"
                    onClick={handleRefreshClick}
                    style={{ paddingBottom: 0 }}
                  >
                    <CloseIcon style={{ color: '#000000' }} />
                  </IconButton>
                </div>
              </div>
              <DialogTitle
                id="alert-dialog-title"
                style={{ paddingBottom: 0, paddingTop: 0 }}
              >
                <span style={{ fontSize: '20px' }}>{t('referral.title4')}</span>
              </DialogTitle>
              <Form {...form}>
                <DialogContent style={{ paddingTop: 0 }}>
                  <Field
                    name="referralCode"
                    label={t('referral.subtitle4')}
                    inputType="textfield"
                    className={classNames(classes.textField, classes.resize)}
                    control={control}
                  />
                </DialogContent>
                <DialogActions>
                  <div className="pull-right">
                    <Button
                      variant="outlined"
                      onClick={() => sendReferralCode(neverDiscount)}
                    >
                      {t('referral.btn4')}
                    </Button>
                    <Button
                      type="submit"
                      variant="contained"
                      className={classes.button}
                    >
                      {t('referral.btn3')}
                    </Button>
                  </div>
                </DialogActions>
              </Form>
            </Dialog>
            {/* KAS-375 Show dialog to warning that salary is less than 500 after sending referral code */}
            {isCodeActivated === true ? (
              <Dialog
                open={
                  gross_salary_without_vat < 500 &&
                  allSalaries.length < 4 &&
                  selectedRows.length === 1
                }
              >
                <DialogTitle id="alert-dialog-title">
                  <div
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <div style={{ margin: 'auto' }}>
                      <span
                        style={{
                          fontSize: '16px',
                          display: 'flex',
                          justifyContent: 'center',
                          paddingTop: '5px'
                        }}
                      >
                        {t('referral.title7')}
                      </span>
                    </div>
                    <div>
                      <FontAwesome
                        name="window-close"
                        style={{
                          color: '#F67131'
                        }}
                        size="lg"
                        onClick={closeDialogSalary}
                      />
                    </div>
                  </div>
                  <span className={classes.subTitle}>
                    {t('referral.title7a')}
                  </span>
                  <span className={classes.subTitle}>
                    {t('referral.title7b')}
                  </span>
                </DialogTitle>
              </Dialog>
            ) : null}
            {/* Show snackbar when the code is sent failed or success */}
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={sendCodeSuccess}
              autoHideDuration={4000}
              onClose={() => closeSalarySnackbar()}
            >
              <MySnackbarContentWrapper
                variant="success"
                message={t('referral.notice1')}
                onClose={() => closeSalarySnackbar()}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={nerverUseDiscount}
              autoHideDuration={4000}
              onClose={() => closeSalarySnackbar()}
            >
              <MySnackbarContentWrapper
                variant="success"
                message={t('referral.notice3')}
                onClose={() => closeSalarySnackbar()}
              />
            </Snackbar>
            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              open={sendCodeFailed}
              autoHideDuration={4000}
              onClose={() => closeSalarySnackbar()}
            >
              <MySnackbarContentWrapper
                variant="error"
                message={t('referral.notice2')}
                onClose={() => closeSalarySnackbar()}
              />
            </Snackbar>
          </div>
        )
      }}
    </Translation>
  )
}

NewSalarySummaryComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(NewSalarySummaryComponent)
